import { getCarouselArrayTransformed } from '../../transformers/carousel-array-transformer';

const configJson = {
  tabType: 'playlist',
  playlistID: '2222',
  showBottomThumbnails: false,
  showAllVideosButton: true,
  allVideosButtonLabel: 'All videos',
  allVideosButtonUrl: 'https://allvideourl.com',
  nextVideoSuggested: false,
  nextVideoPlaylist: true,
  audiooff: false,
  autoplay: true,
  tabTitle: 'Tab 2',
  singleVideoType: false,
  liveType: false,
  playlistType: true,
  sectionsType: false,
  tagsType: false,
};

export const getCarouselData = async (baseUrl, tabData = configJson, hlPrevTags) => {
  const assetsList = await getCarouselArrayTransformed(tabData, baseUrl, hlPrevTags);
  return assetsList;
};
